import 'vanilla-cookieconsent/dist/cookieconsent'
// import 'vanilla-cookieconsent/src/cookieconsent' use only for debug

const ccnstL = typeof window.ccnstL !== 'undefined' ? window.ccnstL : '#'
import { languages } from './translations'

const cc = initCookieConsent()

cc.run({
    auto_language: 'document',
    use_rfc_cookie: true,
    cookie_necessary_only_expiration: 3,
    force_consent: false,
    languages: languages,
    hide_from_bots: true,
    gui_options: {
      consent_modal: {
        layout: 'bar',
        position: 'bottom center',
        transition: 'slide'
      },
      settings_modal: {
        layout: 'box',
        position: 'left',
        transition: 'slide'
      }
    },
    onAccept: (cookie) => {
      setTimeout(() => {
        gtag('consent', 'update', {
          analytics_storage: cc.allowedCategory('analytics') ? 'granted' : 'denied',
          ad_storage: cc.allowedCategory('advertising') ? 'granted': 'denied',
          personalization_storage: cc.allowedCategory('advertising') ? 'granted': 'denied',
          ad_user_data: cc.allowedCategory('advertising') ? 'granted': 'denied',
          ad_personalization: cc.allowedCategory('advertising') ? 'granted': 'denied'
        })
        dataLayer.push({'event': 'analytics_storage'})
        dataLayer.push({'event': 'ad_storage'})
      },0);
    },
    onChange: (cookie, changed_categories) => {
      if (changed_categories.indexOf('analytics') > -1) {
        gtag('consent', 'update', {
          analytics_storage: cc.allowedCategory('analytics') ? 'granted' : 'denied'
        })
        dataLayer.push({'event': 'analytics_storage'})
      }

      if (changed_categories.indexOf('advertising') > -1) {
        gtag('consent', 'update', {
          analytics_storage: cc.allowedCategory('analytics') ? 'granted' : 'denied',
          ad_storage: cc.allowedCategory('advertising') ? 'granted': 'denied',
          personalization_storage: cc.allowedCategory('advertising') ? 'granted': 'denied',
          ad_user_data: cc.allowedCategory('advertising') ? 'granted': 'denied',
          ad_personalization: cc.allowedCategory('advertising') ? 'granted': 'denied'
        })
        dataLayer.push({'event': 'analytics_storage'})
        dataLayer.push({'event': 'ad_storage'})
      }
    }
});

// add link to deny all except technical cookies
const element = document.querySelector("#c-bns");
if(element) {
  const lang = document.documentElement.lang
  let translation = languages['en']
  if(Object.prototype.hasOwnProperty.call(languages, lang)) {
    translation = languages[lang]
  }
  const deny = document.createElement("div");
  deny.id = "c-txt";
  deny.className = 'cc-deny'
  deny.style.marginTop = '0.7em';
  deny.innerHTML = translation.consent_modal.additional_text + ' <a href="javascript:void(0);" id="c-deny">' + translation.consent_modal.additional_text_btn.text + '</a>.';
  element.after(deny);

  document.getElementById("c-deny").addEventListener('click', function() {
    cc.hide();
    cc.accept([]);
  });
}
